module.exports = __webpack_public_path__ + "static/TS-Gaby-e4d0c950af927306eaef0f20aac67fcc.gif";